import { ExportSettingsType } from '@/pages/DataHub/Export/ExportSettingsContext';
import { getStartEndIsoDate } from '@/utils/getStartEndIsoDate';

export const getFromToValues = (exportSettings: ExportSettingsType) => {
  let fromValue: string | null = '';
  let toValue: string | null = '';

  switch (exportSettings.exportType) {
    case 'all':
      fromValue = 'all';
      break;
    case 'range':
      fromValue = `${exportSettings.periodNumber}${exportSettings.period}`;
      break;
    case 'dates':
      fromValue = getStartEndIsoDate(exportSettings.from, 'start');
      toValue = getStartEndIsoDate(exportSettings.to, 'end');
      break;
    default:
      fromValue = 'all';
  }
  return { fromValue, toValue };
};
